// @ts-nocheck

export default {
  "l10n": {
    "currency": '\u20ac',
    "date": {
      "months": {
        "full": ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"],
        "abbr": ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"]
      },
      "days": {
        "full": ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
        "abbr": ["sun", "mon", "tue", "wed", "thu", "fri", "sat"]
      },
      "patterns": {
        "longDate": "dddd, MMMM D, YYYY",
        "dateSlash": "MM/DD/YYYY",
        "dateShort": "dddd, MMMM D",
        "dateShortWithDay": "Do MMMM YYYY",
        "dateMedium": "dddd, MMMM D - h[:]mm a",
        "dateMediumReversed" : "H[:]mm - D MMMM YYYY",
        "dateMediumSlash": "DD[/]MM[/]YYYY H[:]mm a",
        "dateLarge": "D MMM YYYY h[:]mm a",
        "timeShort": "LT",
        "timeMedium": "DD[/]MM [•] LT",
        "timeLarge": "DD[/]MM[/]YY [•] LT"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["(Sn)", "Sn"]
      },
      "group": {
        "separator": ",",
        "length": 3,
        "abbr": ["", "k", "M", "B"]
      },
      "decimal": {
        "separator": ".",
        "length": 2
      },
      "ordinal": function(number) { var b = number % 10; return number + ((number % 100 / 10) === 1 ? 'th' : (b === 1) ? 'st' : (b === 2) ? 'nd' : (b === 3) ? 'rd' : 'th'); }
    }
  },
  "translations": {
    "messages": {
  "!action:Bet": [
    null,
    "Bet"
  ],
  "!action:GiftRace Start": [
    null,
    "Start"
  ],
  "!action:Settings": [
    null,
    "Settings"
  ],
  "!action:Share": [
    null,
    "Share"
  ],
  "!action:deleteAndContinue": [
    null,
    "Delete and continue"
  ],
  "!action:viewMyNonValidatedBets": [
    null,
    "View my non-validated bets"
  ],
  "!desc:%1$s ES RM J-30 warning": [
    null,
    ""
  ],
  "!desc:ArjelAdvice": [
    null,
    "Any person wishing to ban themselves from gambling must do so via the interior ministry. This interdiction applies to casinos, gaming clubs and online gaming websites according to law n° 2010-476 of May 12th 2010. It lasts for a period of three years and cannot be reduced."
  ],
  "!desc:ArjelLink": [
    null,
    "Voluntary gaming interdiction"
  ],
  "!desc:ArjelTitle": [
    null,
    "Winamax is certified by the ANJ (Autorité Nationale des Jeux)"
  ],
  "!desc:BROptaWidgetWarning": [
    null,
    "All betting results relating to shots will be based on official data from the organizer and not the statistics displayed above."
  ],
  "!desc:BasketHowTo": [
    null,
    "Add bets to your selection by clicking on the odds"
  ],
  "!desc:BetBuilderHelper": [
    null,
    "With MyMatch, you can create a bet choosing multiple selections from a single match and get your personalised odds."
  ],
  "!desc:BetBuilderHelperBasketball": [
    null,
    "With MyMatch, you can create a bet choosing multiple selections from a single match (match winner, number of points/rebounds/assists made by a player) and get your personalised odds."
  ],
  "!desc:BetBuilderHelperSoccer": [
    null,
    "With MyMatch, you can create a bet choosing multiple selections from a single match (half-time result, correct score, number of goals, goalscorers etc.) and get your personalised odds."
  ],
  "!desc:BetshareWebsite": [
    null,
    "winamax.fr"
  ],
  "!desc:BzgaLegals": [
    null,
    "Eigentümer und Betreiber - Winamax SA - 136 B Rue de Grenelle, 75007 Paris, Frankreich\nGlücksspiel kann süchtig machen. Hilfe unter"
  ],
  "!desc:CashoutPendingRegulation": [
    null,
    "The Cashout amount is only paid out when all selections of the bet have been settled"
  ],
  "!desc:ClientUpdaterContent": [
    null,
    "In order to update the software, please uninstall the current version you have installed, and then download the new software straight from the App Store."
  ],
  "!desc:ClientUpdaterContentDeprecated": [
    null,
    "This version of the software does not have the latest updates and will soon be blocked."
  ],
  "!desc:DEBetTaxFreeDescription": [
    null,
    "We take over the betting tax for you in the amount of 5.3% on the bet. With us you bet guaranteed tax-free, which means more profits for you!"
  ],
  "!desc:DVTMLink": [
    null,
    "Verantwortliches Spiel"
  ],
  "!desc:DgojConfidentiality": [
    null,
    "Política de privacidad"
  ],
  "!desc:DgojLicence": [
    null,
    "\n        WINAMAX Sociedad Anónima (S.A.) cuya sede social se encuentra en 136bis Rue de Grenelle, 75007 París France.\n        Todos los derechos reservados.\n\n        WINAMAX se responsabiliza de este sitio web, al que la Dirección General de Ordenación del Juego le ha concedido las siguientes licencias: POQUER No/Ref: POQ/2018/001, APUESTAS DEPORTIVAS DE CONTRAPARTIDA No/Ref: ADC/2018/017\n\n        Está prohibida la participación de los menores de edad y los incapacitados legalmente o por resolución judicial.\n      "
  ],
  "!desc:DgojResponsibleGaming": [
    null,
    "Juego responsable"
  ],
  "!desc:DgojResponsibleGamingTextES": [
    null,
    "This is a real money gambling application. Please play responsibly and only bet what you can afford. For help and support with gambling addiction, please contact FEJAR at 900 533 025 or visit https://fejar.org/"
  ],
  "!desc:DgojTerms": [
    null,
    "Términos y condiciones"
  ],
  "!desc:DocumentTitle": [
    null,
    "Sports bets | Winamax sports bets | Online sports bets"
  ],
  "!desc:DocumentTitleLive": [
    null,
    "Bet In Play - Bet on sports live on Winamax"
  ],
  "!desc:FreebetHelper": [
    null,
    "Free bets are available through our promotional offers.\nOnly your net winnings (winnings - wager) will be credited to your account should you win your free bet."
  ],
  "!desc:GoalScorersHelper": [
    null,
    "Bet on a player to score at least one goal or precisely the first or last goal of the game. These bets do not include any eventual extra-time or penalty shoot-outs. Own goals are not counted. If the first (or last) goal of the game is an own goal, then the player who scores the next goal (or the before-last goal) will be considered as the first goalscorer (or last goalscorer) of the game."
  ],
  "!desc:Minus18DE": [
    null,
    "Minderjährigen ist die Benutzung verboten"
  ],
  "!desc:MonopolyEnrollmentMessage": [
    null,
    "Complete your Monopoly collections thanks to your bets and win Freebets!"
  ],
  "!desc:PanicButtonConfirmation": [
    null,
    "You have activated a 24h break across all providers. You can play again earliest on tomorrow at %1$s."
  ],
  "!desc:PanicButtonConfirmationTitle": [
    null,
    "Your account is on a break"
  ],
  "!desc:RealityCheckMessage": [
    null,
    "Don't forget to take regular breaks. You can also find more information in the 'Player Protection' section of our website."
  ],
  "!desc:ResponsibleGamingTextFR": [
    null,
    "This is a real-money gambling app. Please gamble responsibly and only bet what you can afford. For gambling addiction help and support, please contact (joueurs-info-service at 09-74-75-13-13or visit http://www.joueurs-info-service.fr/."
  ],
  "!desc:SoccerDecisivePlayer": [
    null,
    "Concerning the 2 bets \"decisive player\" and \"decisive pass\", the bets will be cancelled if the player concerned does not play. Furthermore, the result of the bets is based on Opta statistics.\nThe player will be decisive in the match, i.e. score at least one goal or make at least one assist (excluding overtime and penalty shoot-out)."
  ],
  "!desc:SoccerScorerDuo": [
    null,
    "Bet on the number of goals scored by two players during the match (excluding extra-time and penalty shoot-out). This bet will be reimbursed if one the selected players does not play."
  ],
  "!desc:SoccerScorerTrio": [
    null,
    "Bet on the number of goals scored by these three players during the match (excluding extra-time and penalty shoot-out). This bet will be reimbursed if one the selected players does not play."
  ],
  "!desc:SrijLicence": [
    null,
    "WINAMAX, S.A. Todos os direitos reservados. É uma empresa registada em Portugal com o número de empresa XXXXXXXXX, com sede na XXXXXXXX, em XXXXX e é titular das licenças de jogo n° XXX e XXX emitidas pelo SRIJ – Serviço de Regulação e Inspeção de Jogos que a autoriza a desenvolver a atividade de exploração de apostas desportivas à cota e de jogos de fortuna ou azar online em Portugal."
  ],
  "!desc:activateLineUpNotifications": [
    null,
    "Would you like to receive a notification when the starting line-ups are in place on your favourite matches?\nActivate your notifications from your communication preferences"
  ],
  "!desc:userAlreadyOptedIn": [
    null,
    "You have already enrolled to this operation."
  ],
  "!noun:GridsCancelled": [
    null,
    "Cancelled"
  ],
  "!noun:GridsFilterCancelled": [
    null,
    "Cancelled"
  ],
  "!noun:GridsFilterLost": [
    null,
    "Lost"
  ],
  "!noun:GridsFilterRunning": [
    null,
    "Running"
  ],
  "!noun:GridsFilterWon": [
    null,
    "Won"
  ],
  "!noun:GridsFinancing": [
    null,
    "Financing"
  ],
  "!noun:GridsFinished": [
    null,
    "Finished"
  ],
  "!noun:GridsLost": [
    null,
    "Lost"
  ],
  "!noun:GridsNotValidated": [
    null,
    "Not validated"
  ],
  "!noun:GridsRunning": [
    null,
    "Running"
  ],
  "!noun:GridsWon": [
    null,
    "Won"
  ],
  "!noun:MonopolyWon": [
    "!noun:MonopolyWonPlural",
    "Won:",
    "Won:"
  ],
  "!noun:Rules": [
    null,
    "Rules"
  ],
  "!noun:Welcome": [
    null,
    "Welcome"
  ],
  "!noun:Won": [
    null,
    "Won"
  ],
  "!plural:Finished": [
    null,
    "Finished"
  ],
  "!plural:Won": [
    null,
    "Won"
  ],
  "!scorer:Next": [
    null,
    "Next"
  ],
  "!short:1st half - 2 or more": [
    null,
    "1st half - 2 or more"
  ],
  "!short:1st half - 3 or more": [
    null,
    "1st half - 3 or more"
  ],
  "!short:1st half - 4 or more": [
    null,
    "1st half - 4 or more"
  ],
  "!short:1st period - Scorer": [
    null,
    "1st period - Scorer"
  ],
  "!short:2 or more": [
    null,
    "2 or more"
  ],
  "!short:2nd half - 2 or more": [
    null,
    "2nd half - 2 or more"
  ],
  "!short:2nd half - 3 or more": [
    null,
    "2nd half - 3 or more"
  ],
  "!short:2nd half - 4 or more": [
    null,
    "2nd half - 4 or more"
  ],
  "!short:2nd period - Scorer": [
    null,
    "2nd period - Scorer"
  ],
  "!short:3 or more": [
    null,
    "3 or more"
  ],
  "!short:3rd period - Scorer": [
    null,
    "3rd period - Scorer"
  ],
  "!short:4 or more": [
    null,
    "4 or more"
  ],
  "!short:AdditionnalTime": [
    null,
    "EI"
  ],
  "!short:Anytime goalscorer": [
    null,
    "Anytime goalscorer"
  ],
  "!short:BothHalf": [
    null,
    "Both"
  ],
  "!short:Double": [
    null,
    "Double"
  ],
  "!short:Draw": [
    null,
    "X"
  ],
  "!short:First": [
    null,
    "First"
  ],
  "!short:FirstHalf": [
    null,
    "1st"
  ],
  "!short:HalfTime": [
    null,
    "HT"
  ],
  "!short:Hat-trick": [
    null,
    "Hat-trick"
  ],
  "!short:Last": [
    null,
    "Last"
  ],
  "!short:Next": [
    null,
    "Next"
  ],
  "!short:Overtime": [
    null,
    "P"
  ],
  "!short:Overtime - 2 or more": [
    null,
    "Overtime - 2 or more"
  ],
  "!short:PenaltyShootOut": [
    null,
    "PSO"
  ],
  "!short:Points": [
    null,
    "PTS"
  ],
  "!short:RegularTime": [
    null,
    "Reg Time"
  ],
  "!short:ScorerConversion": [
    null,
    "C"
  ],
  "!short:ScorerDrop": [
    null,
    "D"
  ],
  "!short:ScorerPenalty": [
    null,
    "P"
  ],
  "!short:SecondHalf": [
    null,
    "2nd"
  ],
  "!short:Today": [
    null,
    "Today"
  ],
  "!short:bet": [
    "!short:bets",
    "bet",
    "bets"
  ],
  "%1$s (multiple chance)": [
    null,
    "%1$s (multiple chance)"
  ],
  "%1$s + %2$s": [
    null,
    "%1$s + %2$s"
  ],
  "%1$s Base": [
    "%1$s Bases",
    "%1$s Base",
    "%1$s Bases"
  ],
  "%1$s bet": [
    "%1$s bets",
    "%1$s bet",
    "%1$s bets"
  ],
  "%1$s bet added": [
    "%1$s bets added",
    "%1$s bet added",
    "%1$s bets added"
  ],
  "%1$s bet could not be validated": [
    "%1$s bets could not be validated",
    "%1$s bet could not be validated",
    "%1$s bets could not be validated"
  ],
  "%1$s bet selected": [
    "%1$s bets selected",
    "%1$s bet selected",
    "%1$s bets selected"
  ],
  "%1$s guarenteed ": [
    null,
    "%1$s guarenteed"
  ],
  "%1$s or more": [
    null,
    "%1$s or more"
  ],
  "%1$s selection": [
    "%1$s selections",
    "%1$s selection",
    "%1$s selections"
  ],
  "%1$s selection could not be added": [
    "%1$s selections could not be added",
    "%1$s selection could not be added",
    "%1$s selections could not be added"
  ],
  "%1$s single bet": [
    "%1$s single bets",
    "%1$s single bet",
    "%1$s single bets"
  ],
  "%1$s's bet": [
    null,
    "%1$s's bet"
  ],
  "%1$s-%2$s PSO": [
    null,
    "%1$s-%2$s PSO"
  ],
  "%1$s-%2$s a.e.t.": [
    null,
    "%1$s-%2$s a.e.t."
  ],
  "%1$s-%2$s reg. time": [
    null,
    "%1$s-%2$s reg. time"
  ],
  "%1$s:": [
    null,
    "%1$s:"
  ],
  "(1 to %1$s)": [
    null,
    "(1 to %1$s)"
  ],
  "+%1$s min": [
    null,
    "+%1$s min"
  ],
  "10th set": [
    null,
    "10th set"
  ],
  "12-grids": [
    null,
    "12-grids"
  ],
  "1st": [
    null,
    "1st"
  ],
  "1st half": [
    null,
    "1st half"
  ],
  "1st innings": [
    null,
    "1st innings"
  ],
  "1st period": [
    null,
    "1st period"
  ],
  "1st quarter": [
    null,
    "1st quarter"
  ],
  "1st set": [
    null,
    "1st set"
  ],
  "2 or more": [
    null,
    "2 or more"
  ],
  "24-hour break": [
    null,
    "24-hour break"
  ],
  "2nd": [
    null,
    "2nd"
  ],
  "2nd half": [
    null,
    "2nd half"
  ],
  "2nd half - Multiple goalscorers": [
    null,
    "2nd half - Multiple goalscorers"
  ],
  "2nd innings": [
    null,
    "2nd innings"
  ],
  "2nd period": [
    null,
    "2nd period"
  ],
  "2nd quarter": [
    null,
    "2nd quarter"
  ],
  "2nd set": [
    null,
    "2nd set"
  ],
  "3 or more": [
    null,
    "3 or more"
  ],
  "3rd": [
    null,
    "3rd"
  ],
  "3rd innings": [
    null,
    "3rd innings"
  ],
  "3rd period": [
    null,
    "3rd period"
  ],
  "3rd quarter": [
    null,
    "3rd quarter"
  ],
  "3rd set": [
    null,
    "3rd set"
  ],
  "4 or more": [
    null,
    "4 or more"
  ],
  "4th innings": [
    null,
    "4th innings"
  ],
  "4th quarter": [
    null,
    "4th quarter"
  ],
  "4th set": [
    null,
    "4th set"
  ],
  "5th innings": [
    null,
    "5th innings"
  ],
  "5th set": [
    null,
    "5th set"
  ],
  "6th innings": [
    null,
    "6th innings"
  ],
  "6th set": [
    null,
    "6th set"
  ],
  "7-grids": [
    null,
    "7-grids"
  ],
  "7th innings": [
    null,
    "7th innings"
  ],
  "7th set": [
    null,
    "7th set"
  ],
  "8th innings": [
    null,
    "8th innings"
  ],
  "8th set": [
    null,
    "8th set"
  ],
  "9th innings": [
    null,
    "9th innings"
  ],
  "9th set": [
    null,
    "9th set"
  ],
  "A server issue has interrupted media playback.": [
    null,
    "A server issue has interrupted media playback."
  ],
  "ALL-IN": [
    null,
    "ALL-IN"
  ],
  "Accept changes": [
    null,
    "Accept changes"
  ],
  "Acces to media failed.": [
    null,
    "Acces to media failed."
  ],
  "Accumulator": [
    null,
    "Accumulator"
  ],
  "Accumulator %1$s": [
    null,
    "Accumulator %1$s"
  ],
  "Add": [
    null,
    "Add"
  ],
  "Add an In-Play selection to get a %1$s bonus": [
    null,
    "Add an In-Play selection to get a %1$s bonus"
  ],
  "Add bet to basket": [
    null,
    "Add bet to basket"
  ],
  "Add one selection to get a %1$s bonus": [
    null,
    "Add one selection to get a %1$s bonus"
  ],
  "Additional buttons allow you to make variations of an existing grid.": [
    null,
    "Additional buttons allow you to make variations of an existing grid."
  ],
  "Ajax Amsterdam": [
    null,
    "Ajax Amsterdam"
  ],
  "All": [
    null,
    "All"
  ],
  "All my grids": [
    null,
    "All my grids"
  ],
  "All players": [
    null,
    "All players"
  ],
  "All possible accumulators %1$s with %2$s from %3$s others, or %4$s in total": [
    null,
    "All possible accumulators %1$s with %2$s from %3$s others, or %4$s in total"
  ],
  "All possible accumulators from the %1$s from amongst %2$s, or %3$s in total": [
    null,
    "All possible accumulators from the %1$s from amongst %2$s, or %3$s in total"
  ],
  "All rules": [
    null,
    "All rules"
  ],
  "Amount": [
    null,
    "Amount"
  ],
  "Amount collected:": [
    null,
    "Amount collected:"
  ],
  "Amount shared out:": [
    null,
    "Amount shared out:"
  ],
  "Amount to be carried forward:": [
    null,
    "Amount to be carried forward:"
  ],
  "An error as occurred.": [
    null,
    "An error as occurred."
  ],
  "An error has occured": [
    null,
    "An error has occured"
  ],
  "An error occurred, please try again.": [
    null,
    "An error occurred, please try again."
  ],
  "And remember,": [
    null,
    "And remember,"
  ],
  "And you will unlock phase 2.": [
    null,
    "And you will unlock phase 2."
  ],
  "And you will unlock phase 3.": [
    null,
    "And you will unlock phase 3."
  ],
  "Anytime": [
    null,
    "Anytime"
  ],
  "Assistman": [
    null,
    "Assistman"
  ],
  "Assists": [
    null,
    "Assists"
  ],
  "Assists+rebounds": [
    null,
    "Assists+rebounds"
  ],
  "At least one of the two teams": [
    null,
    "At least one of the two teams"
  ],
  "At least one of your multi-chance selections has too many choices.": [
    null,
    "At least one of your multi-chance selections has too many choices."
  ],
  "At least one of your selections is currently suspended": [
    null,
    "At least one of your selections is currently suspended."
  ],
  "At least one of your selections is no longer available.": [
    null,
    "At least one of your selections is no longer available."
  ],
  "At least one of your selections is no longer available. Check your betslip.": [
    null,
    "At least one of your selections is no longer available. Check your betslip."
  ],
  "At least one of your selections is not eligible for MyMatch.": [
    null,
    "At least one of your selections is not eligible for MyMatch."
  ],
  "At least one of your selections is not eligible for MyMatch. Check your betslip.": [
    null,
    "At least one of your selections is not eligible for MyMatch. Check your betslip."
  ],
  "Atletico Madrid": [
    null,
    "Atletico Madrid"
  ],
  "Author": [
    null,
    "Author"
  ],
  "BOOM, easy game!": [
    null,
    "BOOM, easy game!"
  ],
  "Back": [
    null,
    "Back"
  ],
  "Back to grid creation": [
    null,
    "Back to grid creation"
  ],
  "Back to sports betting": [
    null,
    "Back to sports betting"
  ],
  "Back to the grid of the day": [
    null,
    "Back to the grid of the day"
  ],
  "Balance": [
    null,
    "Balance"
  ],
  "Base": [
    null,
    "Base"
  ],
  "Bayern Munich": [
    null,
    "Bayern Munich"
  ],
  "Best author (badge)": [
    null,
    "Best author (badge)"
  ],
  "Best author (winnings)": [
    null,
    "Best author (winnings)"
  ],
  "Best bets": [
    null,
    "Best bets"
  ],
  "Bet": [
    null,
    "Bet"
  ],
  "Bet %1$s could not be redeemed, one or more selections are not eligible for Cashout": [
    null,
    "Bet %1$s could not be redeemed, one or more selections are not eligible for Cashout"
  ],
  "Bet %1$s could not be redeemed, remaining bet is less than €0.10": [
    null,
    "Bet %1$s could not be redeemed, remaining bet is less than €0.10"
  ],
  "Bet %1$s could not be redeemed, the Cashout amount has changed": [
    null,
    "Bet %1$s could not be redeemed, the Cashout amount has changed"
  ],
  "Bet confirmation": [
    null,
    "Bet confirmation"
  ],
  "Bet is limited to free bet": [
    null,
    "Bet is limited to free bet"
  ],
  "Bet is not eligible for Boom %1$s": [
    null,
    "Bet is not eligible for Boom %1$s"
  ],
  "Bet is not eligible for Boom %1$s because at least one match starts after the end of the game": [
    null,
    "Bet is not eligible for Boom %1$s because at least one match starts after the end of the game"
  ],
  "Bet is not eligible for Boom %1$s because system bets are not eligible": [
    null,
    "Bet is not eligible for Boom %1$s because system bets are not eligible"
  ],
  "Bet is not eligible for Boom %1$s because the game is not in progress": [
    null,
    "Bet is not eligible for Boom %1$s because the game is not in progress"
  ],
  "Bet is not eligible for Boom %1$s because the match starts in over 48 hours": [
    null,
    "Bet is not eligible for Boom %1$s because the match starts in over 48 hours"
  ],
  "Bet is not eligible for Boom %1$s because you have a bet in the validation process": [
    null,
    "Bet is not eligible for Boom %1$s because you have a bet in the validation process"
  ],
  "Bet is not eligible for Boom %1$s because you have already placed an eligible bet on the same match": [
    null,
    "Bet is not eligible for Boom %1$s because you have already placed an eligible bet on the same match"
  ],
  "Bet is not eligible for Boom %1$s because you have not started the game": [
    null,
    "Bet is not eligible for Boom %1$s because you have not started the game"
  ],
  "Bet is not eligible for Monopoly": [
    null,
    "Bet is not eligible for Monopoly"
  ],
  "Bet is not eligible for Monopoly because at least one match starts after the end of the game": [
    null,
    "Bet is not eligible for Monopoly because at least one match starts after the end of the game"
  ],
  "Bet is not eligible for Monopoly because system bets are not eligible": [
    null,
    "Bet is not eligible for Monopoly because system bets are not eligible"
  ],
  "Bet is not eligible for Monopoly because the game is not in progress": [
    null,
    "Bet is not eligible for Monopoly because the game is not in progress"
  ],
  "Bet is not eligible for Monopoly because the match starts in over 48 hours": [
    null,
    "Bet is not eligible for Monopoly because the match starts in over 48 hours"
  ],
  "Bet is not eligible for Monopoly because you have already placed an eligible bet on the same match": [
    null,
    "Bet is not eligible for Monopoly because you have already placed an eligible bet on the same match"
  ],
  "Bet is not eligible for Monopoly because you have not started the game": [
    null,
    "Bet is not eligible for Monopoly because you have not started the game"
  ],
  "Bet is not eligible for the Gift Race": [
    null,
    "Bet is not eligible for the Gift Race"
  ],
  "Bet is not eligible for the Gift Race because at least one match starts after the end of the game": [
    null,
    "Bet is not eligible for the Gift Race because at least one match starts after the end of the game"
  ],
  "Bet is not eligible for the Gift Race because system bets are not eligible": [
    null,
    "Bet is not eligible for the Gift Race because system bets are not eligible"
  ],
  "Bet is not eligible for the Gift Race because the game is not in progress": [
    null,
    "Bet is not eligible for the Gift Race because the game is not in progress"
  ],
  "Bet is not eligible for the Gift Race because the match starts in over 48 hours": [
    null,
    "Bet is not eligible for the Gift Race because the match starts in over 48 hours"
  ],
  "Bet is not eligible for the Gift Race because this version of the game has ended": [
    null,
    "Bet is not eligible for the Gift Race because this version of the game has ended"
  ],
  "Bet is not eligible for the Gift Race because you have a reward to collect in order to unlock the next gift": [
    null,
    "Bet is not eligible for the Gift Race because you have a reward to collect in order to unlock the next gift"
  ],
  "Bet is not eligible for the Gift Race because you have already placed an eligible bet on the same match": [
    null,
    "Bet is not eligible for the Gift Race because you have already placed an eligible bet on the same match"
  ],
  "Bet is not eligible for the Gift Race because you have already won the gift": [
    null,
    "Bet is not eligible for the Gift Race because you have already won the gift"
  ],
  "Bet is not eligible for the Gift Race because you have not started the game": [
    null,
    "Bet is not eligible for the Gift Race because you have not started the game"
  ],
  "Bet is not eligible for the Gift Race because you must start the gift quest again": [
    null,
    "Bet is not eligible for the Gift Race because you must start the gift quest again"
  ],
  "Bet is not eligible for the Gift Race because your current bets will be decisive": [
    null,
    "Bet is not eligible for the Gift Race because your current bets will be decisive"
  ],
  "Bet modification unavailable": [
    null,
    "Bet modification unavailable"
  ],
  "Bet modification unavailable with free bets": [
    null,
    "Bet modification unavailable with free bets"
  ],
  "Bet pending": [
    null,
    "Bet pending"
  ],
  "Bet refused": [
    null,
    "Bet refused"
  ],
  "Bet stopped": [
    null,
    "Bet stopped"
  ],
  "Bet suspended": [
    null,
    "Bet suspended"
  ],
  "Bet tax free": [
    null,
    "Bet tax free"
  ],
  "Bet validated": [
    null,
    "Bet validated"
  ],
  "Bet validated!": [
    null,
    "Bet validated!"
  ],
  "Bet validation in progress": [
    null,
    "Bet validation in progress"
  ],
  "Bets on the competition": [
    null,
    "Bets on the competition"
  ],
  "Betslip": [
    null,
    "Betslip"
  ],
  "Betting with Winamax": [
    null,
    "Betting with Winamax"
  ],
  "Biggest accumulators": [
    null,
    "Biggest accumulators"
  ],
  "Biggest winnings": [
    null,
    "Biggest winnings"
  ],
  "Blocks": [
    null,
    "Blocks"
  ],
  "Boom %1$s internal error": [
    null,
    "Boom %1$s internal error"
  ],
  "Boom St Valentine": [
    null,
    "Boom St Valentine"
  ],
  "Borussia M'Gladbach": [
    null,
    "Borussia M'Gladbach"
  ],
  "Both teams": [
    null,
    "Both teams"
  ],
  "Bracket": [
    null,
    "Bracket"
  ],
  "Bravo!": [
    null,
    "Congrats!"
  ],
  "By ticking this box, your grid will be made private.": [
    null,
    "By ticking this box, your grid will be made private."
  ],
  "Cancelled": [
    null,
    "Cancelled"
  ],
  "Cashout": [
    null,
    "Cashout"
  ],
  "Cashout (max %1$s)": [
    null,
    "Cashout (max %1$s)"
  ],
  "Cashout validated": [
    null,
    "Cashout validated"
  ],
  "Cashout validation in progress": [
    null,
    "Cashout validation in progress"
  ],
  "Cashout €%1$s": [
    null,
    "Cashout €%1$s"
  ],
  "Cashout: %2$s available": [
    "Cashout: %2$s available",
    "Cashout: %2$s available",
    "Cashout: %2$s available"
  ],
  "Certain data may not be up to date.": [
    null,
    "Certain data may not be up to date."
  ],
  "Check out the public grids as well as information about the authors of these grids and find the one that suits you best.": [
    null,
    "Check out the public grids as well as information about the authors of these grids and find the one that suits you best."
  ],
  "Check the full rules": [
    null,
    "Check the full rules"
  ],
  "Choose the amount of your stake on this grid as a team.": [
    null,
    "Choose the amount of your stake on this grid as a team."
  ],
  "Choose your format (7 or 12 matches) and validate your own grid.": [
    null,
    "Choose your format (7 or 12 matches) and validate your own grid."
  ],
  "Christmas is already over!": [
    null,
    "Christmas is already over!"
  ],
  "Claim": [
    null,
    "Claim"
  ],
  "Click and hold an image to save or share": [
    null,
    "Click and hold an image to save or share"
  ],
  "Close": [
    null,
    "Close"
  ],
  "Close details": [
    null,
    "Close details"
  ],
  "Combinations": [
    null,
    "Combinations"
  ],
  "Combo booster": [
    null,
    "Combo booster"
  ],
  "Compact grid": [
    null,
    "Compact grid"
  ],
  "Compact view": [
    null,
    "Compact view"
  ],
  "Competitions": [
    null,
    "Competitions"
  ],
  "Complete all 3 phases of the game by placing winning bets and walk away with legendary gifts and lots of Freebets:": [
    null,
    "Complete all 3 phases of the game by placing winning bets and walk away with legendary gifts and lots of Freebets:"
  ],
  "Complete bet": [
    null,
    "Complete bet"
  ],
  "Confirm": [
    null,
    "Confirm"
  ],
  "Congratulations on your journey!": [
    null,
    "Congratulations on your journey!"
  ],
  "Congratulations!": [
    null,
    "Congratulations!"
  ],
  "Connection error.": [
    null,
    "Connection error."
  ],
  "Contradictory selections": [
    null,
    "Contradictory selections"
  ],
  "Contradictory selections.": [
    null,
    "Contradictory selections."
  ],
  "Contradictory selections. Check your betslip.": [
    null,
    "Contradictory selections. Check your betslip."
  ],
  "Copied": [
    null,
    "Copied"
  ],
  "Copy": [
    null,
    "Copy"
  ],
  "Copy the link": [
    null,
    "Copy the link"
  ],
  "Countries": [
    null,
    "Countries"
  ],
  "Dead-Heat": [
    null,
    "Dead-Heat"
  ],
  "Decisive": [
    null,
    "Decisive"
  ],
  "Decisive players": [
    null,
    "Decisive players"
  ],
  "Delete grid": [
    null,
    "Delete grid"
  ],
  "Delete my favourites": [
    null,
    "Delete my favourites"
  ],
  "Detailed grids": [
    null,
    "Detailed grids"
  ],
  "Didn't understand everything on the previous screen?": [
    null,
    "Didn't understand everything on the previous screen?"
  ],
  "Direct free kick": [
    null,
    "Direct free kick"
  ],
  "Display sliders on relevant bets by default": [
    null,
    "Display sliders on relevant bets by default"
  ],
  "Do you like this application?": [
    null,
    "Do you like this application?"
  ],
  "Do you want to keep a low profile and only share your grid with your friends? Opt for the private grid.": [
    null,
    "Do you want to keep a low profile and only share your grid with your friends? Opt for the private grid."
  ],
  "Do you wish to comment on this application?": [
    null,
    "Do you wish to comment on this application?"
  ],
  "Don't save bet": [
    null,
    "Don't save bet"
  ],
  "Draw": [
    null,
    "Draw"
  ],
  "Duplicate grid": [
    null,
    "Duplicate grid"
  ],
  "Each simple bet is placed individually": [
    null,
    "Each simple bet is placed individually"
  ],
  "Edit": [
    null,
    "Edit"
  ],
  "Enhance": [
    null,
    "Enhance"
  ],
  "Error whilst crediting your reward": [
    null,
    "Error whilst crediting your reward"
  ],
  "Error, please try again": [
    null,
    "Error, please try again"
  ],
  "Event abandoned": [
    null,
    "Event abandoned"
  ],
  "Event cancelled": [
    null,
    "Event cancelled"
  ],
  "Event ended": [
    null,
    "Event ended"
  ],
  "Event postponed": [
    null,
    "Event postponed"
  ],
  "Eventual winnings will be shared in proportion to each player's stake.": [
    null,
    "Eventual winnings will be shared in proportion to each player's stake."
  ],
  "Excluding extra-time and penalty shoot-out.": [
    null,
    "Excluding extra-time and penalty shoot-out."
  ],
  "Explode Cupid by winnings 5 bets": [
    null,
    "Explode Cupid by winnings 5 bets"
  ],
  "Explode the leprechaun by winnings 5 bets": [
    null,
    "Explode the leprechaun by winnings 5 bets"
  ],
  "Explode your pumpkin by winnings 5 bets": [
    null,
    "Explode your pumpkin by winnings 5 bets"
  ],
  "Extras": [
    null,
    "Extras"
  ],
  "FC Porto": [
    null,
    "FC Porto"
  ],
  "Filter bets": [
    null,
    "Filter bets"
  ],
  "Finance your entire grid or share the jackpot by playing as a team.": [
    null,
    "Finance your entire grid or share the jackpot by playing as a team."
  ],
  "Find out how much you've pocketed as soon as the last game of your grid ends.": [
    null,
    "Find out how much you've pocketed as soon as the last game of your grid ends."
  ],
  "First": [
    null,
    "First"
  ],
  "Flash": [
    null,
    "Flash"
  ],
  "Follow the live results and stats of your grids.": [
    null,
    "Follow the live results and stats of your grids."
  ],
  "For a 24h break hold the button pressed for 3 seconds.": [
    null,
    "For a 24h break hold the button pressed for 3 seconds."
  ],
  "Format change": [
    null,
    "Format change"
  ],
  "Frame %1$s": [
    null,
    "Frame %1$s"
  ],
  "Freebet Wager": [
    null,
    "Freebet wager"
  ],
  "Freebet win for the complete colour collection: Reference bet x %1$s": [
    null,
    "Freebets win for the complete colour collection: Reference bet x %1$s"
  ],
  "Freebet winnings if you win this level: Reference bet x %1$s": [
    null,
    "Freebet winnings if you win this level: Reference bet x %1$s"
  ],
  "Freebets Wager": [
    null,
    "Freebets Wager"
  ],
  "Game objective": [
    null,
    "Game objective"
  ],
  "Gather properties, complete colour collections and win lots of Freebets!": [
    null,
    "Gather properties, complete colour collections and win lots of Freebets!"
  ],
  "General problem": [
    null,
    "General issue"
  ],
  "Get started": [
    null,
    "Get started"
  ],
  "Gift Race internal error": [
    null,
    "Gift Race internal error"
  ],
  "Goalscorer Duo": [
    null,
    "Goalscorer Duo"
  ],
  "Goalscorer Guarantee": [
    null,
    "Goalscorer Guarantee"
  ],
  "Goalscorer Trio": [
    null,
    "Goalscorer Trio"
  ],
  "Goalscorer in a period": [
    null,
    "Goalscorer in a period"
  ],
  "Goalscorers in a 10 min period": [
    null,
    "Goalscorers in a 10 min period"
  ],
  "Goalscorers in a 15 min period": [
    null,
    "Goalscorers in a 15 min period"
  ],
  "Graphics preferences": [
    null,
    "Graphics preferences"
  ],
  "Grid": [
    null,
    "Grid"
  ],
  "Grid %1$s winnings": [
    null,
    "Grid %1$s winnings"
  ],
  "Grid price": [
    null,
    "Grid price"
  ],
  "Grid result": [
    null,
    "Grid result"
  ],
  "Grids": [
    null,
    "Grids"
  ],
  "Grids Home": [
    null,
    "Grids Home"
  ],
  "Guarantee:": [
    null,
    "Guarantee:"
  ],
  "Half time - Multiple goalscorers": [
    null,
    "Half time - Multiple goalscorers"
  ],
  "Half-time goalscorers": [
    null,
    "Half-time goalscorers"
  ],
  "Halloween": [
    null,
    "Halloween"
  ],
  "Header": [
    null,
    "Header"
  ],
  "Hidden": [
    null,
    "Hidden"
  ],
  "Hide bet": [
    null,
    "Hide bet"
  ],
  "Highest MyMatch odds": [
    null,
    "Highest MyMatch odds"
  ],
  "Highest odds": [
    null,
    "Highest odds"
  ],
  "Home": [
    null,
    "Home"
  ],
  "If you lose a bet, you start the phase from 0.": [
    null,
    "If you lose a bet, you start the phase from 0."
  ],
  "Important account information": [
    null,
    "Important account information"
  ],
  "In Play": [
    null,
    "Live"
  ],
  "In progress": [
    null,
    "In progress"
  ],
  "Incorrect PIN": [
    null,
    "Incorrect PIN"
  ],
  "Incorrect amount": [
    null,
    "Incorrect amount"
  ],
  "Incorrect email, password or date of birth": [
    null,
    "Incorrect email, password or date of birth"
  ],
  "Individual grid": [
    null,
    "Individual grid"
  ],
  "Inter Milan": [
    null,
    "Inter Milan"
  ],
  "Internal error": [
    null,
    "Internal error"
  ],
  "It's not the grids that matter, it's what you do with them!": [
    null,
    "It's not the grids that matter, it's what you do with them!"
  ],
  "It's simple! Select a result of your choice (team 1 or team 2 or draw) for each match.": [
    null,
    "It's simple! Select a result of your choice (team 1 or team 2 or draw) for each match."
  ],
  "Koh-Lanta": [
    null,
    "Koh-Lanta"
  ],
  "Lacking inspiration? You can also take part in a public grid.": [
    null,
    "Lacking inspiration? You can also take part in a public grid."
  ],
  "Last": [
    null,
    "Last"
  ],
  "Later": [
    null,
    "Later"
  ],
  "Least expensive": [
    null,
    "Least expensive"
  ],
  "Less selections": [
    null,
    "Less selections"
  ],
  "Level %1$s": [
    null,
    "Level %1$s"
  ],
  "Line %1$s": [
    null,
    "Line %1$s"
  ],
  "Link copied!": [
    null,
    "Link copied!"
  ],
  "Live": [
    null,
    "Live"
  ],
  "Liverpool": [
    null,
    "Liverpool"
  ],
  "Loading": [
    null,
    "Loading"
  ],
  "Loading in progress": [
    null,
    "Loading..."
  ],
  "Log in": [
    null,
    "Log in"
  ],
  "Log in to %1$s": [
    null,
    "Log in to %1$s"
  ],
  "Lost": [
    null,
    "Lost"
  ],
  "Maintenance in progress": [
    null,
    "Maintenance in progress"
  ],
  "Maintenance in progress.": [
    null,
    "Maintenance in progress."
  ],
  "Manchester City": [
    null,
    "Manchester City"
  ],
  "Manchester United": [
    null,
    "Manchester United"
  ],
  "Map %1$s": [
    null,
    "Map %1$s"
  ],
  "Marseille": [
    null,
    "Marseille"
  ],
  "Match": [
    null,
    "Match"
  ],
  "Match details": [
    null,
    "Match details"
  ],
  "Match details and odds": [
    null,
    "Match details and odds"
  ],
  "Match ended": [
    null,
    "Match ended"
  ],
  "Match odds": [
    null,
    "Match odds"
  ],
  "Match result odds": [
    null,
    "Match result odds"
  ],
  "Match unavailable": [
    null,
    "Match unavailable"
  ],
  "Matches": [
    null,
    "Matches"
  ],
  "Maximum selections reached": [
    null,
    "Maximum selections reached"
  ],
  "Min. odds": [
    null,
    "Min. odds"
  ],
  "Min. odds:": [
    null,
    "Min. odds:"
  ],
  "Min. wager:": [
    null,
    "Min. wager:"
  ],
  "Minimum odds to win this card: %1$s": [
    null,
    "Minimum odds to win this card: %1$s"
  ],
  "Minimum odds to win this level: %1$s": [
    null,
    "Minimum odds to win this level: %1$s"
  ],
  "Monopoly internal error": [
    null,
    "Monopoly internal error"
  ],
  "More selections": [
    null,
    "More selections"
  ],
  "Most advanced": [
    null,
    "Most advanced"
  ],
  "Most expensive": [
    null,
    "Most expensive"
  ],
  "Most popular": [
    null,
    "Most popular"
  ],
  "Most recent": [
    null,
    "Most recent"
  ],
  "Multiples:": [
    null,
    "Multiples:"
  ],
  "Multiscorers": [
    null,
    "Multiscorers"
  ],
  "My bets": [
    null,
    "My bets"
  ],
  "My collection": [
    null,
    "My collection"
  ],
  "My favourites": [
    null,
    "My favourites"
  ],
  "My grids": [
    null,
    "My grids"
  ],
  "My wager": [
    null,
    "My wager"
  ],
  "My winnings": [
    null,
    "My winnings"
  ],
  "MyMatch currently unavailable": [
    null,
    "MyMatch currently unavailable."
  ],
  "MyMatch mode": [
    null,
    "MyMatch mode"
  ],
  "MyMatch unavailable": [
    null,
    "MyMatch unavailable"
  ],
  "News": [
    null,
    "News"
  ],
  "Next": [
    null,
    "Next"
  ],
  "Next grid": [
    null,
    "Next grid"
  ],
  "Next grids": [
    null,
    "Next grids"
  ],
  "No": [
    null,
    "No"
  ],
  "No bets": [
    null,
    "No bets"
  ],
  "No grid": [
    null,
    "No grid"
  ],
  "No grid played": [
    null,
    "No grid played"
  ],
  "No grids": [
    null,
    "No grids"
  ],
  "No grids cancelled": [
    null,
    "No grids cancelled"
  ],
  "No grids lost": [
    null,
    "No grids lost"
  ],
  "No grids running": [
    null,
    "No grids running"
  ],
  "No grids won": [
    null,
    "No grids won"
  ],
  "No public grids": [
    null,
    "No public grids"
  ],
  "No rank 1 winners": [
    null,
    "No rank 1 winners"
  ],
  "No results": [
    null,
    "No results"
  ],
  "No team": [
    null,
    "No team"
  ],
  "Non-top 10 competitor": [
    null,
    "Non-top 10 competitor"
  ],
  "Non-top 30 competitor": [
    null,
    "Non-top 30 competitor"
  ],
  "Not enough combinations": [
    null,
    "Not enough combinations"
  ],
  "Notifications": [
    null,
    "Notifications"
  ],
  "Number": [
    null,
    "Number"
  ],
  "Number of bets": [
    null,
    "Number of bets"
  ],
  "Number of goals from the player": [
    null,
    "Number of goals from the player"
  ],
  "Odds": [
    null,
    "Odds"
  ],
  "Odds equal or inferior to 1": [
    null,
    "Odds equal or inferior to 1"
  ],
  "Odds:": [
    null,
    "Odds:"
  ],
  "Official lineups": [
    null,
    "Official lineups"
  ],
  "Official starting lineups": [
    null,
    "Official starting lineups"
  ],
  "Ok": [
    null,
    "Ok"
  ],
  "Olympiakos": [
    null,
    "Olympiakos"
  ],
  "One or multiple selections are unavailable": [
    null,
    "One or multiple selections are unavailable"
  ],
  "Ongoing": [
    null,
    "Ongoing"
  ],
  "Oops,": [
    null,
    "Oops,"
  ],
  "Open the App Store": [
    null,
    "Open the App Store"
  ],
  "PRA": [
    null,
    "PRA"
  ],
  "Paris SG": [
    null,
    "Paris SG"
  ],
  "Penalty": [
    null,
    "Penalty"
  ],
  "Penalty try": [
    null,
    "Penalty try"
  ],
  "Pending %1$s bets": [
    null,
    "Pending %1$s bets"
  ],
  "Pending bet refused": [
    null,
    "Pending bet refused"
  ],
  "Pending bet validated": [
    null,
    "Pending bet validated"
  ],
  "Permanent and past promotions": [
    null,
    "Permanent and past promotions"
  ],
  "Phase 1: Pegasus Shoes": [
    null,
    "Phase 1: Pegasus Shoes"
  ],
  "Phase 2: The remote control ball": [
    null,
    "Phase 2: The remote control ball"
  ],
  "Phase 3: The Chameleon Jersey": [
    null,
    "Phase 3: The Chameleon Jersey"
  ],
  "Place a series of winning bets to score %1$s points.": [
    null,
    "Place a series of winning bets to score %1$s points."
  ],
  "Play the game to try and win a ton of Freebets!": [
    null,
    "Play the game to try and win a ton of Freebets!"
  ],
  "Player": [
    null,
    "Player"
  ],
  "Player vs. player": [
    null,
    "Player vs. player"
  ],
  "Player vs. team": [
    null,
    "Player vs. team"
  ],
  "Please enter a valid amount.": [
    null,
    "Please enter a valid amount."
  ],
  "Please enter your date of birth": [
    null,
    "Please enter your date of birth"
  ],
  "Points": [
    null,
    "Points"
  ],
  "Points structure: 100 x product (winning odds). Thus, if your first 3 bets are winners, you win 100 x odds1 x odds2 x odds3 points.": [
    null,
    "Points structure: 100 x product (winning odds). Thus, if your first 3 bets are winners, you win 100 x odds1 x odds2 x odds3 points."
  ],
  "Points+assists": [
    null,
    "Points+assists"
  ],
  "Points+rebounds": [
    null,
    "Points+rebounds"
  ],
  "Poker": [
    null,
    "Poker"
  ],
  "Potential winnings": [
    null,
    "Potential winnings"
  ],
  "Previous": [
    null,
    "Previous"
  ],
  "Prize distribution per player": [
    null,
    "Prize distribution per player"
  ],
  "Prizepool": [
    null,
    "Prizepool"
  ],
  "Probable starting lineups": [
    null,
    "Probable starting lineups"
  ],
  "Prohibited": [
    null,
    "Prohibited"
  ],
  "Prohibited (no-stakes game)": [
    null,
    "Prohibited (no-stakes game)"
  ],
  "Projected lineups": [
    null,
    "Projected lineups"
  ],
  "Provisional grid result": [
    null,
    "Provisional grid result"
  ],
  "Provisional prize distribution": [
    null,
    "Provisional prize distribution"
  ],
  "Public grid": [
    null,
    "Public grid"
  ],
  "Public grids": [
    null,
    "Public grids"
  ],
  "Real Madrid": [
    null,
    "Real Madrid"
  ],
  "Rebounds": [
    null,
    "Rebounds"
  ],
  "Ref:": [
    null,
    "Ref:"
  ],
  "Reference": [
    null,
    "Reference"
  ],
  "Reference bet: the smallest bet of the levels you have won (max %1$s)": [
    null,
    "Reference bet: the smallest bet of the levels you have won (max %1$s)"
  ],
  "Refuse": [
    null,
    "Refuse"
  ],
  "Refused": [
    null,
    "Refused"
  ],
  "Repeat this bet": [
    null,
    "Repeat this bet"
  ],
  "Reset": [
    null,
    "Reset"
  ],
  "Reset the grid": [
    null,
    "Reset the grid"
  ],
  "Result": [
    null,
    "Result"
  ],
  "Retired or defaulted": [
    null,
    "Retired or defaulted"
  ],
  "Reviews": [
    null,
    "Reviews"
  ],
  "Right-click an image to copy it or to save it on your device": [
    null,
    "Right-click an image to copy it or to save it on your device"
  ],
  "Rules": [
    null,
    "Terms and conditions"
  ],
  "Running": [
    null,
    "Running"
  ],
  "Save bet": [
    null,
    "Save bet"
  ],
  "Save my selection": [
    "Save my selections",
    "Save my selection",
    "Save my selections"
  ],
  "Saved": [
    null,
    "Saved"
  ],
  "Scan a bonus code": [
    null,
    "Scan a bonus code"
  ],
  "Scorer": [
    null,
    "Scorer"
  ],
  "Scorer type": [
    null,
    "Type of goal by a player"
  ],
  "Scorers": [
    null,
    "Scorers"
  ],
  "Search": [
    null,
    "Search"
  ],
  "See all": [
    null,
    "See all"
  ],
  "See all odds": [
    null,
    "See all odds"
  ],
  "See details": [
    null,
    "Details"
  ],
  "See more selections": [
    null,
    "See more selections"
  ],
  "See top matches": [
    null,
    "See top matches"
  ],
  "Select": [
    null,
    "Select"
  ],
  "Service unavailable": [
    null,
    "Service unavailable"
  ],
  "Settings": [
    null,
    "Settings"
  ],
  "Shaktar Donetsk": [
    null,
    "Shaktar Donetsk"
  ],
  "Share bet to a friend's basket": [
    null,
    "Share bet to a friend's basket"
  ],
  "Share image": [
    null,
    "Share image"
  ],
  "Share my bet": [
    null,
    "Share my bet"
  ],
  "Share options": [
    null,
    "Share options"
  ],
  "Shop": [
    null,
    "Shop"
  ],
  "Show animation when adding a selection to betslip": [
    null,
    "Show animation when adding a selection to betslip"
  ],
  "Show bet": [
    null,
    "Show bet"
  ],
  "Show username": [
    null,
    "Show username"
  ],
  "Show wager and winnings": [
    null,
    "Show wager and winnings"
  ],
  "Sign-in": [
    null,
    "Sign-in"
  ],
  "Sign-in and place bet": [
    null,
    "Sign-in and place bet"
  ],
  "Sign-up": [
    null,
    "Sign-up"
  ],
  "Simple touchdown scorer": [
    null,
    "Scorer"
  ],
  "Single": [
    null,
    "Single"
  ],
  "Skip all": [
    null,
    "Skip all"
  ],
  "Sports": [
    null,
    "Sports"
  ],
  "Sports bets": [
    null,
    "Sports bets"
  ],
  "St Patrick": [
    null,
    "St Patrick"
  ],
  "St Valentine": [
    null,
    "St Valentine"
  ],
  "Start": [
    null,
    "Start"
  ],
  "Start again": [
    null,
    "Start again"
  ],
  "Starter": [
    null,
    "Starter"
  ],
  "Starters": [
    null,
    "Starters"
  ],
  "Starting 5 Guarantee": [
    null,
    "Starting 5 Guarantee"
  ],
  "Stats": [
    null,
    "Stats"
  ],
  "Steals": [
    null,
    "Steals"
  ],
  "Steals+blocks": [
    null,
    "Steals+blocks"
  ],
  "Substitutes": [
    null,
    "Substitutes"
  ],
  "System": [
    null,
    "System"
  ],
  "System %1$s": [
    null,
    "System %1$s"
  ],
  "System %1$s/%2$s": [
    null,
    "System %1$s/%2$s"
  ],
  "System bet": [
    null,
    "System bet"
  ],
  "System grid": [
    null,
    "System grid"
  ],
  "System grid price": [
    null,
    "System grid price"
  ],
  "Take part": [
    null,
    "Take part"
  ],
  "Team 1": [
    null,
    "Team 1"
  ],
  "Team 2": [
    null,
    "Team 2"
  ],
  "Team grid": [
    null,
    "Team grid"
  ],
  "Terms and Conditions and Privacy Policy": [
    null,
    "Terms and Conditions and Privacy Policy"
  ],
  "The Gift Race": [
    null,
    "The Gift Race"
  ],
  "The Pegasus shoes to fly over your next match": [
    null,
    "The Pegasus shoes to fly over your next match"
  ],
  "The bet is not eligible for Boom %1$s because Freebets are not taken into account": [
    null,
    "The bet is not eligible for Boom %1$s because Freebets are not taken into account"
  ],
  "The bet is not eligible for Monopoly because Freebets are not taken into account": [
    null,
    "The bet is not eligible for Monopoly because Freebets are not taken into account"
  ],
  "The chameleon jersey to change teams in a flash": [
    null,
    "The chameleon jersey to change teams in a flash"
  ],
  "The classic accumulator wins if the %1$s are correct": [
    null,
    "The classic accumulator wins if the %1$s are correct"
  ],
  "The date of birth entered does not match the date registered on your account": [
    null,
    "The date of birth entered does not match the date registered on your account"
  ],
  "The date of birth you have entered is invalid": [
    null,
    "The date of birth you have entered is invalid"
  ],
  "The game is over": [
    null,
    "The game is over"
  ],
  "The game will end in under 24 hours": [
    null,
    "The game will end in under 24 hours"
  ],
  "The maximum stake for this bet has already been reached, or the stake is lower than the minimum of €0.10": [
    null,
    "The maximum stake for this bet has already been reached, or the stake is lower than the minimum of €0.10"
  ],
  "The maximum wager is %1$s": [
    null,
    "The maximum wager is %1$s"
  ],
  "The minimum odds are %1$s": [
    null,
    "The minimum odds are %1$s"
  ],
  "The minimum wager is %1$s": [
    null,
    "The minimum wager is %1$s"
  ],
  "The odds have changed": [
    null,
    "The odds have changed"
  ],
  "The prize for this collection has already been claimed": [
    null,
    "The prize for this collection has already been claimed"
  ],
  "The remote-controlled ball with its unpredictable trajectories": [
    null,
    "The remote-controlled ball with its unpredictable trajectories"
  ],
  "The service is currently unavailable. We will restore this as soon as possible. We apologise for any inconveniences caused by this.": [
    null,
    "The service is currently unavailable. We will restore this as soon as possible. We apologise for any inconveniences caused by this."
  ],
  "The system grid is an expert mode. It allows you to create complex grids with some basic matches.": [
    null,
    "The system grid is an expert mode. It allows you to create complex grids with some basic matches."
  ],
  "The video could not be loaded as it is an unsupported video format or due to a server issue.": [
    null,
    "The video could not be loaded as it is an unsupported video format or due to a server issue."
  ],
  "This QR code is not a Winamax bonus code": [
    null,
    "This QR code is not a Winamax bonus code"
  ],
  "This broadcast is not available in your country of residence.": [
    null,
    "This broadcast is not available in your country of residence."
  ],
  "This code is not a Winamax bonus code or has already been credited": [
    null,
    "This code is not a Winamax bonus code or has already been credited"
  ],
  "This event is no longer available": [
    null,
    "This event is no longer available"
  ],
  "This free bet cannot be used": [
    null,
    "This free bet cannot be used"
  ],
  "This match is already included in the betslip you wish to enhance.": [
    null,
    "This match is already included in the betslip you wish to enhance."
  ],
  "This promotion has ended": [
    null,
    "This promotion has ended"
  ],
  "This promotion will end in under 24 hours": [
    null,
    "This promotion will end in under 24 hours"
  ],
  "This version of the software is not supported": [
    null,
    "This version of the software is not supported"
  ],
  "This video could not be loaded as it has unsupported functionalities.": [
    null,
    "This video could not be loaded as it has unsupported functionalities."
  ],
  "Three-pointers": [
    null,
    "Three-pointers"
  ],
  "Tick the boxes in your grid.": [
    null,
    "Tick the boxes in your grid."
  ],
  "To be won": [
    null,
    "To be won"
  ],
  "Tomorrow": [
    null,
    "Tomorrow"
  ],
  "Too many attempts.": [
    null,
    "Too many attempts."
  ],
  "Too many bankers": [
    null,
    "Too many bankers"
  ],
  "Too many bets selected": [
    null,
    "Too many bets selected"
  ],
  "Too many selections": [
    null,
    "Too many selections"
  ],
  "Top competitions": [
    null,
    "Top competitions"
  ],
  "Total": [
    null,
    "Total"
  ],
  "Total away": [
    null,
    "Total away"
  ],
  "Total home": [
    null,
    "Total home"
  ],
  "Total odds": [
    null,
    "Total odds"
  ],
  "Total wager": [
    null,
    "Total wager"
  ],
  "Total winnings": [
    null,
    "Total winnings"
  ],
  "Touchdowns scorers": [
    null,
    "Touchdowns scorers"
  ],
  "Try again": [
    null,
    "Try again"
  ],
  "Try scorer Duo": [
    null,
    "Try scorer Duo"
  ],
  "Try scorer Trio": [
    null,
    "Try scorer Trio"
  ],
  "Try scorers": [
    null,
    "Try scorers"
  ],
  "Try:": [
    null,
    "Try:"
  ],
  "Turnovers": [
    null,
    "Turnovers"
  ],
  "Type of goal scored by a team": [
    null,
    "Type of goal scored by a team"
  ],
  "Unable to calculate odds": [
    null,
    "Unable to calculate odds"
  ],
  "Upcoming matches": [
    null,
    "Upcoming matches (calendar)"
  ],
  "Update": [
    null,
    "Update"
  ],
  "Use Freebets": [
    null,
    "Use Freebets"
  ],
  "Use a bonus": [
    null,
    "Use a bonus"
  ],
  "Video unavailable": [
    null,
    "Video unavailable"
  ],
  "View my bet": [
    null,
    "View my bet"
  ],
  "View the most wagered bets in the last %1$s mins": [
    null,
    "View the most wagered bets in the last %1$s mins"
  ],
  "View the most wagered bets in the last hour": [
    null,
    "View the most wagered bets in the last hour"
  ],
  "Wager": [
    null,
    "Wager"
  ],
  "Wager:": [
    null,
    "Wager:"
  ],
  "Walkover": [
    null,
    "Walkover"
  ],
  "Want another accumulator? Switch to MyMatch!": [
    null,
    "Want another accumulator? Switch to MyMatch!"
  ],
  "Want another multi-chance accumulator? Switch to MyMatch!": [
    null,
    "Want another multi-chance accumulator? Switch to MyMatch!"
  ],
  "Want to check out all the promotions Winamax has to offer?": [
    null,
    "Want to check out all the promotions Winamax has to offer?"
  ],
  "Warning:": [
    null,
    "Warning:"
  ],
  "We were unable to generate your final image": [
    null,
    "We were unable to generate your final image"
  ],
  "We'll explain everything step by step!": [
    null,
    "We'll explain everything step by step!"
  ],
  "Welcome to the grid tutorial": [
    null,
    "Welcome to the grid tutorial"
  ],
  "Win a ton of Freebets along the way!": [
    null,
    "Win a ton of Freebets along the way!"
  ],
  "Win all previous levels in order to unlock this level": [
    null,
    "Win all previous levels in order to unlock this level"
  ],
  "Win up to": [
    null,
    "Win up to"
  ],
  "Win up to %1$s times your reference bet in Freebets!": [
    null,
    "Win up to %1$s times your reference bet in Freebets!"
  ],
  "WinaTV channel": [
    null,
    "WinaTV channel"
  ],
  "Winamax QR code": [
    null,
    "Winamax QR code"
  ],
  "Winamax grid": [
    null,
    "Winamax grid"
  ],
  "Winning is everything": [
    null,
    "Winning is everything"
  ],
  "Winnings": [
    null,
    "Winnings"
  ],
  "Winnings %1$s": [
    null,
    "Winnings %1$s"
  ],
  "Winnings inferior or equal to the wager": [
    null,
    "Winnings inferior or equal to the wager"
  ],
  "Won": [
    null,
    "Won"
  ],
  "Xmas": [
    null,
    "Xmas"
  ],
  "Yes": [
    null,
    "Yes"
  ],
  "You aborted the media playback.": [
    null,
    "You aborted the media playback."
  ],
  "You are currently excluded from Monopoly due to your game limits": [
    null,
    "You are currently excluded from Monopoly due to your game limits"
  ],
  "You are currently excluded from betting promotions in your %1$s": [
    null,
    "At present, your %1$s exclude you from receiving sports betting offers."
  ],
  "You are currently excluded from the Gift Race due to your game limits": [
    null,
    "You are currently excluded from the Gift Race due to your game limits"
  ],
  "You are currently ineligible for Boom %1$s": [
    null,
    "You are currently ineligible for Boom %1$s"
  ],
  "You are currently ineligible for Monopoly": [
    null,
    "You are currently ineligible for Monopoly"
  ],
  "You are currently ineligible for the Gift Race": [
    null,
    "You are currently ineligible for the Gift Race"
  ],
  "You are currently not eligible to betting promotions": [
    null,
    "You are currently not eligible to receiving sports betting offers."
  ],
  "You are not authorized to connect from this country.": [
    null,
    "You are not authorized to connect from this country."
  ],
  "You can also make doubles or triples to increase your chances of winning": [
    null,
    "You can also make doubles or triples to increase your chances of winning"
  ],
  "You can also select doubles and triples to have a better chance of winning.": [
    null,
    "You can also select doubles and triples to have a better chance of winning."
  ],
  "You can do so right here! :index_vers_le_bas:": [
    null,
    "You can do so right here!"
  ],
  "You can select doubles and triples to increase your chances of winning.": [
    null,
    "You can select doubles and triples to increase your chances of winning."
  ],
  "You cannot bet on this grid anymore": [
    null,
    "You cannot bet on this grid anymore"
  ],
  "You cannot combine multiple bets on the same match": [
    null,
    "You cannot combine multiple bets on the same match"
  ],
  "You cannot combine these bets": [
    null,
    "You cannot combine these bets"
  ],
  "You have already placed the same bet recently": [
    null,
    "You have already placed the same bet recently"
  ],
  "You have already received your reward": [
    null,
    "You have already received your reward"
  ],
  "You have been active for %1$s minutes now.": [
    null,
    "You have been active for %1$s minutes now."
  ],
  "You have exceeded the maximum stake for this bet": [
    null,
    "You have exceeded the maximum stake for this bet"
  ],
  "You have made a request to change your password. Please check your emails.": [
    null,
    "You have made a request to change your password. Please check your emails."
  ],
  "You have no favourites": [
    null,
    "You have no favourites"
  ],
  "You have no funds in your account.": [
    null,
    "You have no funds in your account."
  ],
  "You lose": [
    null,
    "You lose"
  ],
  "You may not receive a booster on this bet": [
    null,
    "You may not receive a booster on this bet"
  ],
  "You must be logged": [
    null,
    "You must be logged"
  ],
  "You must be logged in to see this page": [
    null,
    "You must be logged in to see this page"
  ],
  "You must be logged in to validate your bets": [
    null,
    "You must be logged in to validate your bets"
  ],
  "You must be logged in to validate your grid.": [
    null,
    "You must be logged in to validate your grid."
  ],
  "You must be of majority age to play": [
    null,
    "You must be 18+ to play"
  ],
  "You must have a minimum of €1 on your account, or you must have placed a bet on this match.": [
    null,
    "You must have a minimum of €1 on your account, or you must have placed a bet on this match."
  ],
  "You must log in to %1$s in order to access your account.": [
    null,
    "You must log in to %1$s in order to access your account."
  ],
  "You must select doubles or triples to make a team grid.": [
    null,
    "You must select doubles or triples to make a team grid."
  ],
  "You must tick at least one box per line.": [
    null,
    "You must tick at least one box per line."
  ],
  "You must wager your deposit in order to withdraw it": [
    null,
    ""
  ],
  "You only have %1$s": [
    null,
    "You only have %1$s"
  ],
  "You only have %1$s in Freebets available": [
    null,
    "You only have %1$s in Freebets available"
  ],
  "You will earn between %1$s and %2$s times your reference bet in Freebets.": [
    null,
    "You will earn between %1$s and %2$s times your reference bet in Freebets."
  ],
  "You will exceed your daily limit. The maximum wager is %1$s": [
    null,
    "You will exceed your daily limit. The maximum wager is %1$s"
  ],
  "You will exceed your monthly limit. The maximum wager is %1$s": [
    null,
    "You will exceed your monthly limit. The maximum wager is %1$s"
  ],
  "You will exceed your weekly limit. The maximum wager is %1$s": [
    null,
    "You will exceed your weekly limit. The maximum wager is %1$s"
  ],
  "You win": [
    null,
    "You win"
  ],
  "You win Freebets": [
    null,
    "You win Freebets"
  ],
  "You won Freebets": [
    null,
    "Tu remportes des Freebets"
  ],
  "You've already won everything!": [
    null,
    "You've already won everything!"
  ],
  "Your %1$s bet could not be cashed out": [
    null,
    "Your %1$s bet could not be cashed out"
  ],
  "Your %1$s bet has been validated": [
    null,
    "Your %1$s bet has been validated"
  ],
  "Your %1$s bet was cashed out for %2$s": [
    null,
    "Your %1$s bet was cashed out for %2$s"
  ],
  "Your account is frozen.": [
    null,
    "Your account is frozen."
  ],
  "Your account is locked": [
    null,
    "Your account is locked"
  ],
  "Your account is not authorized for use in this region": [
    null,
    "Your account is not authorized for use in this region"
  ],
  "Your app is out of date, please update to the latest version": [
    null,
    "Your app is out of date, please update to the latest version"
  ],
  "Your betslip is empty!": [
    null,
    "Your betslip is empty!"
  ],
  "Your bonus code has been accepted": [
    null,
    "Your bonus code has been accepted"
  ],
  "Your email address has not been verified. Please check your emails.": [
    null,
    "Your email address has not been verified. Please check your emails."
  ],
  "Your grid has %1$s double": [
    "Your grid has %1$s doubles",
    "Your grid has %1$s double",
    "Your grid has %1$s doubles"
  ],
  "Your grid has been validated.": [
    null,
    "Your grid has been validated."
  ],
  "Your grid will only be validated once it has been entirely financed.": [
    null,
    "Your grid will only be validated once it has been entirely financed."
  ],
  "Your mission is simple:": [
    null,
    "Your mission is simple:"
  ],
  "Your participation in the game has already been validated": [
    null,
    "Your participation in the game has already been validated"
  ],
  "Your turn to play!": [
    null,
    "Your turn to play!"
  ],
  "Your winnings of %1$s will be credited to you as soon as all bets are settled.": [
    null,
    "Your winnings of %1$s will be credited to you as soon as all bets are settled."
  ],
  "abandoned": [
    null,
    "abandoned"
  ],
  "already received": [
    null,
    "already received"
  ],
  "and %1$s triple": [
    "and %1$s triples",
    "and %1$s triple",
    "and %1$s triples"
  ],
  "break": [
    null,
    "break"
  ],
  "collected": [
    null,
    "collected"
  ],
  "delayed": [
    null,
    "delayed"
  ],
  "events in progress": [
    null,
    "events in progress"
  ],
  "extra innings": [
    null,
    "extra innings"
  ],
  "extra-time": [
    null,
    "extra-time"
  ],
  "extra-time - 1st half": [
    null,
    "extra-time - 1st half"
  ],
  "extra-time - 2nd half": [
    null,
    "extra-time - 2nd half"
  ],
  "extra-time finished": [
    null,
    "extra-time finished"
  ],
  "extra-time half-time": [
    null,
    "extra-time half-time"
  ],
  "extra-time will begin": [
    null,
    "extra-time will begin"
  ],
  "free": [
    null,
    "free"
  ],
  "gaming limits": [
    null,
    "gaming limits"
  ],
  "golden set": [
    null,
    "golden set"
  ],
  "grid %1$s n°%2$s": [
    null,
    "grid %1$s n°%2$s"
  ],
  "grids": [
    null,
    "grids"
  ],
  "guaranteed": [
    null,
    "guaranteed"
  ],
  "half-time": [
    null,
    "half-time"
  ],
  "handicap format": [
    null,
    "handicap format"
  ],
  "how it works": [
    null,
    "how it works"
  ],
  "in progress": [
    null,
    "in progress"
  ],
  "including %1$s:": [
    null,
    "including %1$s:"
  ],
  "including rank 1 deferral:": [
    null,
    "including rank 1 deferral:"
  ],
  "match abandoned": [
    null,
    "match abandoned"
  ],
  "match delayed": [
    null,
    "match delayed"
  ],
  "match finished": [
    null,
    "match finished"
  ],
  "match in progress": [
    null,
    "match in progress"
  ],
  "match interrupted": [
    null,
    "match interrupted"
  ],
  "match interuppted": [
    null,
    "match interrupted"
  ],
  "match postponed": [
    null,
    "match postponed"
  ],
  "match started": [
    null,
    "match started"
  ],
  "missions:AlreadyOpted": [
    null,
    "Registered"
  ],
  "missions:Log in": [
    null,
    "Log in"
  ],
  "missions:Opt in": [
    null,
    "Register"
  ],
  "most popular": [
    null,
    "most popular"
  ],
  "no events": [
    null,
    "no events"
  ],
  "n°": [
    null,
    "n°"
  ],
  "of the base": [
    "of %1$s bases",
    "of the base",
    "of %1$s bases"
  ],
  "ok": [
    null,
    "ok"
  ],
  "or": [
    null,
    "or"
  ],
  "overtime": [
    null,
    "overtime"
  ],
  "overtime finished": [
    null,
    "overtime finished"
  ],
  "overtime will begin": [
    null,
    "overtime will begin"
  ],
  "own goal": [
    null,
    "own goal"
  ],
  "pause": [
    null,
    "pause"
  ],
  "penalty": [
    null,
    "penalty"
  ],
  "penalty shoot-out": [
    null,
    "penalty shoot-out"
  ],
  "retired": [
    null,
    "retired"
  ],
  "selection": [
    "selections",
    "selection",
    "selections"
  ],
  "session break": [
    null,
    "session break"
  ],
  "sudden death": [
    null,
    "sudden death"
  ],
  "text format": [
    null,
    "text format"
  ],
  "the 2nd quarter will begin": [
    null,
    "the 2nd quarter will begin"
  ],
  "the 2nd set will begin": [
    null,
    "the 2nd set will begin"
  ],
  "the 3rd quarter will begin": [
    null,
    "the 3rd quarter will begin"
  ],
  "the 3rd set will begin": [
    null,
    "the 3rd set will begin"
  ],
  "the 4th quarter will begin": [
    null,
    "the 4th quarter will begin"
  ],
  "the 4th set will begin": [
    null,
    "the 4th set will begin"
  ],
  "the 5th set will begin": [
    null,
    "the 5th set will begin"
  ],
  "timer:d": [
    null,
    "d"
  ],
  "timer:finished": [
    null,
    "Finished"
  ],
  "timer:h": [
    null,
    "h"
  ],
  "timer:min": [
    null,
    "min"
  ],
  "up to": [
    null,
    "up to"
  ],
  "walkover": [
    null,
    "walkover"
  ],
  "with your next deposit": [
    null,
    "with your next deposit"
  ]
}
  }
}
